import React from 'react';
import PropTypes from 'prop-types';

export const Fee = ({ width, height, ...props }) => (
  <svg
    data-icon='fee'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M7.5 11a3.372 3.372 0 0 1-2.475-1.025A3.372 3.372 0 0 1 4 7.5c0-.967.342-1.792 1.025-2.475A3.372 3.372 0 0 1 7.5 4c.967 0 1.792.342 2.475 1.025A3.372 3.372 0 0 1 11 7.5c0 .967-.342 1.792-1.025 2.475A3.372 3.372 0 0 1 7.5 11Zm0-2c.417 0 .77-.146 1.063-.438C8.854 8.271 9 7.918 9 7.5c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0 0 7.5 6c-.417 0-.77.146-1.063.438A1.447 1.447 0 0 0 6 7.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437Zm9 11a3.372 3.372 0 0 1-2.475-1.025A3.372 3.372 0 0 1 13 16.5c0-.967.342-1.792 1.025-2.475A3.372 3.372 0 0 1 16.5 13c.967 0 1.792.342 2.475 1.025A3.372 3.372 0 0 1 20 16.5c0 .967-.342 1.792-1.025 2.475A3.372 3.372 0 0 1 16.5 20Zm0-2c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0 0 16.5 15c-.417 0-.77.146-1.063.438A1.446 1.446 0 0 0 15 16.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437ZM5.4 20 4 18.6 18.6 4 20 5.4 5.4 20Z'
    />
  </svg>
);

Fee.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Fee.defaultProps = {
  width: 24,
  height: 24,
};
